<template>
    <div class="habit-page">
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">

                <div class="card card-widget widget-user">
                    <div class="widget-user-header text-white"
                                style="background: url('/assets/images/PexelsForkInRoadAroundBuilding1.jpg')  center;">
                        <h3 class="widget-user-username text-left">Drop unsupportive Action-Habits. <br/>Create supportive ones instead.</h3>
                        <h4 class="widget-user-username text-right">My Action-Habits foretell my Future.</h4>
                    </div>
                    <div class="widget-user-image">
                        <img class="img-circle" src="/assets/images/beginner_child.png" alt="User Avatar">
                    </div>
                </div>
                    <div class=" card card-primary col-sm-12 col-xl-6 mx-auto">
                    <div class="card-header">
                        <h4 class="card-title text-center">How to Setup your Action-Habit Tracker</h4>
                        <div class="card-tools">
                        <button type="button" class="btn btn-tool" data-card-widget="collapse">
                            <i class="fas fa-minus"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-card-widget="remove">
                            <i class="fas fa-times"></i>
                        </button>
                        </div>
                    </div>
                    <div class="card-body" >
                        <div style="text-align:left;" v-html="headerHTML">
                        </div>
                    </div>
                    <!-- /.card-body -->
                    </div>
                    <!-- <div class="list-group-item input-group"> -->
<div class="content-box-gray card mb-2">
 <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >Manage Action-Habits You need to grow/evolve yourself:</h5>
                                    </div>
                        <!-- <h4 style="word-wrap:break-word;align:center;" class="mx-auto bg-dark" >Set up an Action-Habit You need:</h4> -->

                        <div v-if="allactionhabits.length < MAX_ACTION_HABITS" class="row d-flex ">
                            <div  class="col-lg-6 col-md-6">
                                <div class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >Action-Habit</h5>
                                    </div>
                                    <div class="content">
                                        <div class="input-group" style="font-size:.85em;">
                                            <h6 :hidden="!hideHeaderInputs"  style="font-size:.85em;"><em>Habit Name:</em> {{habit_name}}</h6>
                                            <input id="id_habitname" :hidden="hideHeaderInputs" type="text" class="form-control" v-model="habit_name" placeholder="Habit Name: e.g., Healthy Living" required>
                                            <div  :hidden="hideHeaderInputs" class="input-group-append">
                                                <div class="input-group-text">
                                                    <span class="fas fa-file-signature"></span>
                                                    <small class="small text-danger mb-3" v-html="errors.name"></small>
                                                    <small class="small text-primary mb-3" v-html="errors.header"></small>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group" style="font-size:.85em;">
                                            <h6 :hidden="!hideHeaderInputs"  style="font-size:.85em;"><em>Habit Purpose:</em> {{habit_desc}}</h6>
                                            <input id="id_habitdesc" :hidden="hideHeaderInputs" type="text" class="form-control" v-model="habit_desc" placeholder="What this Habit will do for you" required>
                                            <div  :hidden="hideHeaderInputs" class="input-group-append">
                                                <div class="input-group-text">
                                                <span class="fas fa-info"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <small v-if="!current_actionhabitcomponents || current_actionhabitcomponents.length < 1" class="small text-danger mb-1" v-html="errors.header"></small>
                                        <div class=" btn-container">
                                            <!-- {{ habit_name.length}}| {{habit_desc.length }} habit_desc always reports not more than 3, so workaround -->
                                            <button class="btn btn-warning btn-sm" :disabled="(habit_name.length < 4 || habit_desc.length < 3)" :hidden="hideHeaderInputs" id="confHeadBtn" @click="confirmHeaders()"
                                                title="confirm">Step 1: Confirm Action-Habit <span class="fas fa-save"></span>
                                            </button>
                                        </div>
                                        <table style="font-size: .75em;" class="table table-sm table-hover table-light table-striped"  v-if="current_actionhabitcomponents.length> 0">
                                            <thead class="thead-dark"><tr><th>Action-Habit Component<br/><small>(Description)</small></th><th>Action</th></tr></thead>
                                            <tbody>
                                                <tr v-for="hc in current_actionhabitcomponents"  :key="hc.id">
                                                    <td>{{hc.name}}<br/>(<i>{{hc.description}}</i>)</td>
                                                    <td><button class="btn btn-light btn-sm"  title="Delete" v-on:click="deleteComponent(hc.id)"><i class="fas fa-trash text-red"></i></button></td>
                                                </tr>
                                                <tr><td colspan="2">
                                                    <p class="small text-danger mb-1" v-html="errors.hc_confirm"></p>
                                    <button class="btn btn-primary btn-sm" :disabled="checkCreatedHabit()" @click="updateHabitsWatchlist()">Step 3 : Finalize this Action-Habit Definition <i class="fas fa-thumbs-up"></i></button>


                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>

                            <div  class="col-lg-6 col-md-6">
                                <div class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >Action-Habit Component Setup:</h5>
                                    </div>
                                    <div class="content">
                                    <!-- <p class="small text-warning" v-html="errors.maxed_components" :hidden="!maxedOutCustomHabits()"></p> -->
                                        <div class="input-group"  :hidden="maxxedOutCustomHabits()">
                                            <input type="text" v-model="hc_name" id="hc_name_input"  class="form-control"  placeholder="Component Name: e.g., Exercise" required>
                                            <div class="input-group-append">
                                                <div class="input-group-text" >
                                                    <span class="fas fa-pen"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="input-group"  style="font-size: .5em;" :hidden="maxxedOutCustomHabits()">
                                        <input type="text" v-model="hc_desc" id="hc_desc_input"  class="form-control"  placeholder="Description: e.g. At least for 45 mins." required>
                                            <div class="input-group-append">
                                                <div class="input-group-text" >
                                                <span class="fas fa-pen"></span>
                                                </div>
                                            </div>
                                        </div>
                                        <small class="small text-danger mb-1" v-html="errors.hc_add"></small>
                                        <div class="btn-container">
                                            <button class="btn btn-primary btn-sm"  :hidden="maxxedOutCustomHabits()" :disabled="((habit_name.length < 4 || habit_desc.length < 3)||(hc_name.length < 4 || hc_desc.length < 3)) ||maxxedOutCustomHabits()" @click="addCustomHabitCheck()">Step 2<sup>n</sup> : Add Habit Component <i class="fas fa-plus"></i></button>
                                        </div>
                                    </div>
                                </div>
                                <div class="btn-container">
<!-- <p class="small text-danger mb-1" v-html="errors.hc_confirm"></p>                                    <button class="btn btn-primary btn-sm" :disabled="checkCreatedHabit()" @click="updateHabitsWatchlist()">Step 3 : Finalize this Action-Habit Definition <i class="fas fa-thumbs-up"></i></button> -->
                                </div>
                            </div>
                        </div>
<div  v-if="allactionhabits.length>=MAX_ACTION_HABITS" class="row" style="text-align:center;">
    <div class="col-12 mx-auto"><p style="color:brown;">We suggest tracking {{ MAX_ACTION_HABITS }} habits is optimal.<br/>Focus on these {{ MAX_ACTION_HABITS }} and delete/replace them when you've established those habits.</p>
</div>
</div>
                    </div>

                    <div class="row " v-if="allactionhabits.length>0">
                        <div  class="col-auto col-lg-6 col-md-6" style="margin:auto;">
                            <div class="content-box-gray card" >
                                    <div class="title text-center">
                                        <h5 class="mt-2" style="margin:auto;" >My Habits Watch-List:</h5>
                                    </div>
                                    <div class="content">
                                        <table style="font-size: .75em;" class="table table-striped">
                                            <thead class="thead-dark">  <tr ><th>Habit-Name<br/><small>(What it will do for you)</small></th><th>Actions</th></tr></thead>
                                            <tr v-for="habit in allactionhabits" :key="habit.id">
                                                <td><span><em>{{habit.name}}</em><br/><small>{{habit.description}}</small></span></td><td>


                                                    <!-- <i v-on:click="trackHabit(habit.id)" class="fas  fa-shoe-prints" title="Track Habit"></i> &nbsp;
                                                    <i v-on:click="viewHabitResults(habit.id)" class="fas fa-eye fai-blue" title="View Habit Performance"></i> &nbsp; -->
                                                    <i  @click="trackHabit(habit.id)" class="fas fa-shoe-prints fai-green" title="Track My Performance"></i>
                                                    <i  @click="habitPerformance(habit.id)" class="fas fa-eye fai-black" title="View My Performance-Results"></i>
                                                    <i v-if="habit.id != 1" @click="swalConfirmDelete(habit.id)" class="fas fa-trash fai-red" title="Delete Habit"></i>
<i v-else-if="habit.id == 1" ><br/>Must Do</i>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
        <!--    </div>
            </div>
        </div> -->

            </div>
        </div>
    </div>
</template>
<script>

import axios from 'axios';
import EventBus from '../../event-bus';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import { v4 as uuidv4 } from 'uuid';
import HABITSETUPHEADERINFO from '../global/shared/info'


export default {
    components: { Errors },
    name: "ActionHabitSetup",
    data() {
        return {
            MAX_ACTION_HABITS: 4,
            MAX_HABIT_COMPONENTS:4,
            name: '',
            email: '',
            username: '',
            success: false,
            failure: false,
            msg_msg: '',
            token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            loading: false,
            errors: {
                header: '',
                name:'',
                hc_add: '',
                hc_confirm: '',
                maxed_components:''
            },
             userdata: '',
            nahme:'',
            weight:'',
            currentComponent: {
                name:'',
                weight:0
            },
            current_actionhabitdata:[],
            current_actionhabitcomponents:[],
            habit_name: '',
            habitName:'',
            habit_desc:'',
            habitDesc:'',
            hideHeaderInputs:false,
            habitcomponentstally:0,

            // customelementstracker:[],
            selectedDeleteElement:'',
            buttonAwakeN:false,
            buttonAwakeF:false,
            hc_name:'',
            hc_desc:'',
            saved_habit_id: '',
            allactionhabits:[],
            alltrackingdata:[],
            headerHTML: '',

        }
    },
    props: {
        user:'',
        actionhabits:[],
        tracking:[],

    },
    mounted() {
        this.userdata = JSON.parse(this.user);
        this.allactionhabits = JSON.parse(this.actionhabits);
        this.alltrackingdata = JSON.parse(this.tracking);
        this.componentName = new Array(this.MAX_HABIT_COMPONENTS);
        this.deleteComponent = new Array(this.MAX_HABIT_COMPONENTS);
        this.headerHTML = HABITSETUPHEADERINFO;
    },

    methods: {
        updateHabitsWatchlist(){
           console.error('upd called');
           if ( this.habitName != '' ||  this.habitDesc != '' || this.current_actionhabitcomponents.length >1) {
                this.updateToast("Congrats. Your Habit is fully created", 2000, 'success');
                window.location.reload();
           } else {
                // console.error('upd called throwing error');
                this.errors.hc_confirm = 'Please create an Action-Habit (Header) and at least one Action-Habit Component';
            }
        },
        checkCreatedHabit() {
            return !( this.habitName != '' &&  this.habitDesc != ''
                && (this.current_actionhabitcomponents
                && this.current_actionhabitcomponents.length > 0));
        },
        viewHabitResults(habitID) {
            //  console.error('viewHabitChart.....');
            window.location.replace('/actionhabits/'+ habitID + '/results/');
        },
        getGUID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },
        getInputVal(el_id) {
            let inp = document.getElementById(el_id);
            // console.error(inp.value);
            return inp.value;
        },

        confirmHeaders(){
                console.log("Confirming Headers....");
                this.habitName = this.habit_name;
                this.habitDesc = this.habit_desc;
                this.hideHeaderInputs = true;
                this.saveHeaders(this.habitName, this.habitDesc);
        },
        trackHabit(habit_id) {
            console.error('track habit called.....');
            var selHabitData = this.getActionHabitData(habit_id);
            var data = {habitdata: selHabitData, userdata:this.userdata }
            EventBus.$emit('displayActionHabitTrackerModal', data);
        },
        habitPerformance(habit_id) {
            console.error('habitPerformance called.....' + habit_id);
            var selHabitData = this.getActionHabitData(habit_id);
            console.error("Habit: " + selHabitData.name);
            var selActionHabitTrackingData = this.getActionHabitTrackingData(habit_id);
            console.error("Tracking data: " + selActionHabitTrackingData.length);
            var data = {actionhabitdata: selHabitData, userdata:this.userdata, actionhabittrakkerdata: selActionHabitTrackingData};
            EventBus.$emit('displayActionHabitResultsModal', data);
        },
        getActionHabitData(habit_id) {
            // console.log("Looking for Habit with id: " + habit_id);
            var retVal = '';
            this.allactionhabits.forEach((aHabit)=>{
                // console.log(aHabit.name + aHabit.id);
                if(aHabit.id == habit_id)  {
                    // console.log("Found habit: " + aHabit.name);
                    retVal =  aHabit;
                }
            });
            return retVal;
        },
        getActionHabitTrackingData(habit_id) {
            var retVal = [];
             [...this.alltrackingdata].forEach((aTrackingData)=>{
                if(aTrackingData.action_habit_id == habit_id) {
                    console.log("Found: " + aTrackingData.attempt_count + ' ' + aTrackingData.streak + ' ' + aTrackingData.id);
                    retVal.push(aTrackingData);
                }
            });
            return retVal;
        },
        saveHeaders(habit_name, habit_description) {
            axios.post('/actionhabits/saveupdate', {
                user_id:this.userdata.id,
                name: habit_name,
                description: habit_description
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                this.saved_habit_id = res.data.action_habit_id;
                // console.error(res.data.message + ' ' + this.saved_habit_id);
                this.errors.header = "Action-Habit saved.  Now create some components for it!"
                this.failure = false;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(()=> {
                // location.reload();
            });

        },
        deleteComponent(component_id) {
            axios.post('/habits/components/delete', {
                component_id: component_id,
                user_id: this.userdata.id
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                // console.error(res.data.message );
                this.habitdata = JSON.parse(res.data.current_habit);
                this.habitcomponents = this.habitdata.components;
                this.failure = false;
                this.hc_name = '';
                this.hc_desc = '';
                this.hc_weight = '';
                this.errors.hc_add ="";
                this.habitcomponentstally--;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            });
        },
        saveComponent(component_id, name, desc) {
            axios.post('/actionhabits/component/saveupdate', {
                id: component_id,
                action_habit_id: this.saved_habit_id,
                name: name,
                description: desc
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                console.error(res.data.message );
                this.current_actionhabitdata = JSON.parse(res.data.current_action_habit);
                this.current_actionhabitcomponents = this.current_actionhabitdata.components;
console.error(this.current_actionhabitdata );
console.error(this.current_actionhabitcomponents );
                this.failure = false;
                this.hc_name = '';
                this.hc_desc = '';
                this.habitcomponentstally++;
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
             .finally(()=> {
                if(this.success) {
                    console.log("Saved component... doing finally");
                    this.errors.hc_add ="Action-Habit component saved.";
                    if(this.habitcomponentstally>= this.MAX_HABIT_COMPONENTS) {
                        this.errors.hc_add += " Max components created." + this.MAX_HABIT_COMPONENTS;
                    } else {
                        this.errors.hc_add += " Create another one?"
                    }
                    console.log("should display message: " + this.errors.hc_add);
                }
            });
        },

        deleteActionHabit(habit_id) {
            let incomingdata = '';
            console.error("Deleting habit: " + habit_id);
            axios.post('/actionhabits/delete', {
                user_id:this.userdata.id,
                action_habit_id: habit_id
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.msg_msg = res.data.message;
                this.errors.success = true;
                console.error("Deleted habit: " + habit_id  + this.msg_msg);
                this.removeHabitFromHabitData(habit_id);
                this.failure = false;
                this.updateToast(this.msg_msg, 2000, icon='success');
            })
            .catch(err => {
                this.loading = false;
                this.failure = true;
                this.success = false;
            })
            .finally(() => {
                    this.$forceUpdate();
                });
        },
        removeHabitFromHabitData(habit_id) {
             this.allactionhabits = this.allactionhabits.filter(function (habit){
            return habit.id !== habit_id});
        },
        maxxedOutCustomHabits() {
            // console.log(this.habitcomponentstally >= this.MAX_HABIT_COMPONENTS);
            this.errors.maxed_components = 'We recommend not trying to track too many habit components.';
            return this.habitcomponentstally >= this.MAX_HABIT_COMPONENTS;
        },
        addCustomHabitCheck() {
            if(this.hc_name.length >0 && this.hc_desc.length >0) {
                this.saveComponent('', this.hc_name,this.hc_desc);
                this.errors.hc_add =  (this.habitcomponentstally>=4)? "We recommend not trying to track too many habit components.<br/> (Generally 4 components on each habit is a good number).":'';
            } else {
                // console.error("Nothing added to Habit Components...")
                var err = '';
                if(this.hc_name.length<5) err= 'Component Name should be longer than 4 letters';
                this.errors.hc_add = err;
            }
        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },
        swalConfirmDelete(id) {
             Swal.fire({
                title: 'Are you sure?',
                text: "You won't be able to undo this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    // setTimeout( function (id) {
                    //     this.doDeleteSlice(id);
                    // }, 3000);
                    this.deleteActionHabit(id);
                    // Swal.fire(
                    //     'Deletion in progress!',
                    //     '',
                    //     'success'
                    // );
                }
            });
        },
    }
}
</script>

<style scoped>
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:#0707c0;
}
.fai-black{
    color:#000;
}
.content-box-darkblue .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .content {
    overflow:    ;
    padding: 10px;
    font-size: 1.2em;
    /* border-bottom-left-radius: 1em;
    border-bottom-right-radius: 1em; */
    border: 1px solid rgb(15, 9, 9);
    color: #212c3e;
}
.content-box-gray .title {
    height:4em;
    line-height:1.6em;
    border-top-left-radius: .5em;
    border-top-right-radius: .5em;
    background:#0c3acf;
    font-size:.75em;
    /* font-weight:bold; */
    font-family:verdana;
    display:block;
    color:white;
    display:block;
    padding:auto;
    border: 1px solid gray;
    border-bottom:none;
}
.input-group input, select{
    margin-top:.2em;
}
.input-group .input-group-text{
    margin-top:.2em;
}
.shad{
padding:.2em;
padding-top:1em;
margin:.2em;
margin-bottom: 1em;
background: #f1f2f4;
border: 2.5px solid #fff;
border-radius: 4px;
box-shadow: 4px 4px 4px #222;
}
.how-to{
width:80%;
    @media (max-width: 768px) {
        width:90%;
    }
}


</style>
